import { actionTypes } from "constants/types";

let initialState = {
    accounts:[],
    isLoading:false,
    error:""
}

export default function AccountListReducer(state=initialState,action={}){

    switch(action.type){
        case actionTypes.GET_ACCOUNTS_LIST_STARTED:
            return{
                ...state,
                isLoading:true,
            }
        case actionTypes.GET_ACCOUNTS_LIST_SUCCESS:
            return{
                ...state,
                isLoading:false,
                accounts:action.data
            }
        case actionTypes.GET_ACCOUNTS_LIST_FAILED:
            return{
                ...state,
                isLoading:false,
                error:action.error
            }

        default:
            return state;
    }

}